import "./index.scss";

export const SidebarFilterItem = ({
  onItemClick,
  title,
  type,
  items,
  activeFilter
}) => (
  <div className="sidebar-filter-item">
    <h1>{title}</h1>
    <ul>
      {items.map((item) => (
        <li key={item.name}>
          <button
            onClick={() => onItemClick(item, type)}
            className={`${item.name} ${
              activeFilter === (item.value || item.name) ? "active" : ""
            }`}
          >
            {item.title || item.name}
          </button>
        </li>
      ))}
    </ul>
  </div>
);
